function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "win-partner-team-success-business");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 88,
  y: 448,
  width: 16,
  height: 16
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M310.3,384.846A23.985,23.985,0,0,0,288,352H252.944l-4.2-8.4a42.685,42.685,0,0,0-73.695-4.588l-14.578,21.867A15.969,15.969,0,0,1,147.156,368H136v-8a8,8,0,0,0-8-8H16v16H120V480H16v16H128a8,8,0,0,0,8-8v-8h22.138a160.413,160.413,0,0,0,69.639,16H256a23.992,23.992,0,0,0,22.624-32H280a23.992,23.992,0,0,0,22.624-32H304a24,24,0,0,0,6.3-47.154ZM304,416H248v16h32a8,8,0,0,1,0,16H240v16h16a8,8,0,0,1,0,16H227.777a144.3,144.3,0,0,1-64.2-15.155A7.991,7.991,0,0,0,160,464H136V384h11.156a31.935,31.935,0,0,0,26.625-14.25l14.578-21.867a26.687,26.687,0,0,1,46.073,2.868l.624,1.249H216v16h72a8,8,0,0,1,0,16H256v16h48a8,8,0,0,1,0,16Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M512,288H384a8,8,0,0,0-8,8v8H364.844a15.969,15.969,0,0,1-13.313-7.125l-14.578-21.867A42.735,42.735,0,0,0,280,261.75V176h32v40a24.028,24.028,0,0,0,24,24H488a8,8,0,0,0,8-8V80a8,8,0,0,0-8-8H416V64a24.027,24.027,0,0,0-24-24H280a24,24,0,0,0-48,0V288h-8a24.027,24.027,0,0,0-24,24h16a8.009,8.009,0,0,1,8-8h72V288H280v-5.2a26.678,26.678,0,0,1,43.641,1.079l14.578,21.867A31.935,31.935,0,0,0,364.844,320H376v80H352a7.991,7.991,0,0,0-3.578.845,144.109,144.109,0,0,1-15.155,6.517l5.466,15.037a160.057,160.057,0,0,0,15.129-6.4H376v8a8,8,0,0,0,8,8H512V416H392V304H512ZM392,176a8,8,0,0,1,0,16H336a23.885,23.885,0,0,0-8,1.376V176Zm88-88V224H336a8,8,0,0,1,0-16h56a24.028,24.028,0,0,0,24-24V88ZM392,56a8.009,8.009,0,0,1,8,8v97.376A23.885,23.885,0,0,0,392,160H280V56ZM248,288V40a8,8,0,0,1,16,0V288Z"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 408,
  y: 384,
  width: 16,
  height: 16
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 56,
  width: 16,
  height: 160
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 200,
  y: 232,
  width: 16,
  height: 16
});

var SvgWin = function SvgWin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 640",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/win.7b748239.svg";
export { ForwardRef as ReactComponent };